module.exports = __webpack_public_path__ + "img/expulsados.5c470af7.jpg";